"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_BRANDING = void 0;
exports.DEFAULT_BRANDING = {
    logo: 'techsee',
    title: 'Desktop sharing',
    subTitle: 'Please enter the code, provided by the agent',
    buttonText: 'Connect',
    backgroundColor: 'white',
    buttonColor: 'blue',
    validationErrorText: 'The code is required',
    unsupportedTitle: 'Your Browser is not supported',
    unsupportedSubTitle: 'Please try using A different one'
};

//# sourceMappingURL=desktop-sharing.constants.js.map
